const styles = {
  menu: {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translate(-50%)",
    display: "flex",
    zIndex: 2,
    boxShadow: "0 10px 20px rgba(0,0,0,.6)"
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMenu/PlayerMenu.styles.js